import { withAuthorization } from "../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../structure/Page/DefaultPage/DefaultPage";

const MyWorkTimesPageContent = lazy(() => import("./MyWorkTimesPageContent"));

function MyWorkTimesPageInternal() {
    return (
        <DefaultPage>
            <MyWorkTimesPageContent />
        </DefaultPage>
    );
}

export const MyWorkTimesPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE, Role.TEMPORARY_WORKER)
)(MyWorkTimesPageInternal);
